import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";
import Footer from "./Footer.js";
import ArrowRight from "./ArrowRight.js";
import HoriLine from "./HoriLine.js";
import BlobLeft from "./BlobLeft.js";
import BlobRight from "./BlobRight.js";
import LinearProgress from "@mui/material/LinearProgress";
import { ThemeProvider } from '@mui/material/styles';

let stopupdates = function () {};

function ihs(f)
{
	return (window.innerHeight * f) + "px";
}


function AutomaatioMob(p)
{
	return (<div style={{color: "#000000", fontSize: "100%", textAlign:"center"}}>
		<div className="keskitettymob">
			<img height={ihs(0.25)} src={window.AUTOMAATIOTEKSTIT.ekaosiokuvamob} />
		</div>
		<div className="keskitettymob">
		<h1>{window.AUTOMAATIOTEKSTIT.ekaosio}</h1>
		</div>
		<div key="gapihmomia" className="otsikkogap"></div>
		<div className="keskitettymob">
		{window.AUTOMAATIOTEKSTIT.ekaosioekar}
		</div>
		<div key="gapihmomib" className="paragap"></div>
		<div className="keskitettymob">
		{window.AUTOMAATIOTEKSTIT.ekaosiotokar}
		</div>
		<HoriLine fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)"/>
		<div className="keskitettymob">
			<img height={ihs(0.25)} src={window.AUTOMAATIOTEKSTIT.tokaosiokuva} />
		</div>
		<div key="gapihmomic" className="osiogap"></div>
		<div className="keskitettymob">
			<span style={{verticalAlign: "middle"}} >{window.AUTOMAATIOTEKSTIT.tokaosioekar}</span>
		</div>
		<div key="gapihmomid" className="osiogap"></div>

		<div className="keskitettymob">
		<h3>{window.AUTOMAATIOTEKSTIT.kolmasosio}</h3>
		</div>
		<div key="gapihmomie" className="osiogap"></div>
		<div className="keskitettymob">
			<img height={ihs(0.25)} src={window.AUTOMAATIOTEKSTIT.kolmasosiokuva} />
		</div>
		<div className="keskitettymob">
		{window.AUTOMAATIOTEKSTIT.kolmassosioekar}
		</div>
		<div key="gapihmomif" className="paragap"></div>
		<div className="keskitettymob">
		<h3>{window.AUTOMAATIOTEKSTIT.kolmasosiotokar}</h3>
		</div>
		<div key="gapihmomig" className="osiogap"></div>
 		<BlobRight fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)" width="40vh" height="50vh"/>
		<div key="gapihmomigla" className="osiogap"></div>

		<div className="seuraavasivumob">
			<div className="seuraavasivuotsikko" style={{transform: "scale(0.5)"}}>
				<Link to="../luonti" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToLuontiMob} >
					<span style={{color: "#000000", fontSize:"2em", fontWeight:"bold", verticalAlign: "middle"}}>KUVIEN LUONTI</span>
				</Link>
			</div>
			<div style={{transform: "scale(0.75)"}}>
				<Link to="../luonti" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToLuontiMob} >
					<ArrowRight stroke="#000000"/>
				</Link>
			</div>
		</div>
		<div key="gapihmomidsiloppu" className="osiogap"></div>
		<div key="gapihmomidsiloppua" className="osiogap"></div>


		</div>);
}

function moveToLuontiMob()
{
	window.SETLUONTI();
	window.drawLuonti();
}

export default AutomaatioMob;
